import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M48.445 16.304H1.555A24.946 24.946 0 0 0 0 25c0 3.058.55 5.987 1.555 8.696h46.89A24.946 24.946 0 0 0 50 25c0-3.058-.55-5.987-1.555-8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 0C17.423 0 10.633 3.371 6.05 8.696H43.95C39.367 3.37 32.577 0 25.001 0ZM43.951 41.304H6.05C10.633 46.63 17.423 50 25 50s14.367-3.371 18.951-8.696Z"
}));
FlagCR.displayName = 'FlagCR';
export default withFlagWrapper(FlagCR);
//# sourceMappingURL=index.js.map